import React, { useState, useRef } from 'react';
import './LikeSection.scss';

const LikeSection = () => {
    const [liked, setLiked] = useState(false);
    const [dislikePos, setDislikePos] = useState({ x: 0, y: 0 });
    const hoverTimeoutRef = useRef(false);

    const handleLikeClick = () => {
        setLiked(true);
        // Supprimer la classe après 400ms pour permettre d'autres clics
        setTimeout(() => setLiked(false), 400);
    };

    const handleDislikeHover = () => {
        if (hoverTimeoutRef.current) return;

        // Générer une distance aléatoire entre 70px et 200px (positif ou négatif)
        const randomRange = () => (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 130 + 70);
        setDislikePos({ x: randomRange(), y: randomRange() });

        hoverTimeoutRef.current = true;
        setTimeout(() => {
            hoverTimeoutRef.current = false;
        }, 500); // Wait 500ms before allowing another movement
    };

    return (
        <section className="like-section">
            <div
                className={`like-icon thumb-up ${liked ? 'animate-like' : ''}`}
                onClick={handleLikeClick}
            >
                <i className="fas fa-thumbs-up"></i>
            </div>
            <div
                className="like-icon thumb-down"
                onMouseEnter={handleDislikeHover}
                style={{ transform: `translate(${dislikePos.x}px, ${dislikePos.y}px)` }}
            >
                <i className="fas fa-thumbs-down"></i>
            </div>
        </section>
    );
};

export default LikeSection;
